/* eslint-disable no-param-reassign */
import Helpers from './helpers';

const OnSelectFilter = {
	init(element) {
		this.filterForm = element;
		this.filterItems = document.querySelectorAll('.chip-filter__item');
		this.cardsContainer = document.getElementById('cards');
		this.params = new URLSearchParams(window.location.search);
		this.recommendedProjectsEmptyBlock = document.getElementById('recommendedProjectsEmptyBlock');
		this.projectOverviewButton = document.getElementById('projectOverviewButton');
		this.totalCardsShowing = 0;
		this.filterList = [];
		if (this.filterForm) {
			this.setInitialFilterState();
			this.addListeners();
		}
	},

	addListeners() {
		// listen to url changes
		window.addEventListener('popstate', () => {
			this.filterCards();
		});
		[...this.filterItems].forEach((option) => {
			option.addEventListener('click', (e) => {
				e.preventDefault();
				this.updateSearchParams(option);
				this.toggleActive(option);
			});
		});
	},

	createIdList(filterId, filterParamsArr) {
		if (filterParamsArr.includes(filterId)) {
			Helpers.removeItem(filterParamsArr, filterId);
		} else {
			filterParamsArr.push(filterId);
		}
		return filterParamsArr;
	},

	updateSearchParams(option) {
		const filterParamsArr = Helpers.getSearchParams(this.params?.get('skill'));
		// get selected search values
		if (option.dataset.filter) {
			const searchParam = option.dataset.filter;
			const { filterId } = option.dataset;
			const idList = this.createIdList(filterId, filterParamsArr);
			if (idList.length > 0) {
				this.params.set(searchParam, idList);
			} else {
				this.params.delete(searchParam);
			}
		}
		Helpers.pushParameters(this.params);
		window.dispatchEvent(new CustomEvent('popstate'));
		if (filterParamsArr.length === 0) {
			this.renderCardsContainer(this.cardsContainer.children);
		}
	},

	setInitialFilterState() {
		const filterParams = this.params?.get('skill');
		if (filterParams != null) {
			const filterParamsArr = filterParams.split(',').map((item) => item.trim());
			this.reactivateFilterItem(filterParamsArr, this.filterItems);
		}
		this.filterCards();
	},

	reactivateFilterItem(filterParamsArr, filterItems) {
		[...filterItems].forEach((option) => {
			if (filterParamsArr.includes(option.dataset.filterId)) {
				this.toggleActive(option);
			}
		});
	},

	toggleActive(option) {
		if (option.classList.contains('item--active')) {
			option.classList.remove('item--active');
		} else {
			option.classList.add('item--active');
		}
	},

	renderCardsContainer(totalCardsShowing) {
		if (totalCardsShowing === 2) {
			this.recommendedProjectsEmptyBlock.classList.remove('hidden');
			this.cardsContainer.classList.add('recommended-projects__empty-container');
			if (this.cardsContainer.classList.contains('cards-grid')) {
				this.cardsContainer.classList.remove('cards-grid');
			}
			if (this.projectOverviewButton.classList.contains('btn--primary')) {
				this.projectOverviewButton.classList.replace('btn--primary', 'btn--secondary');
			}
		} else {
			this.recommendedProjectsEmptyBlock.classList.add('hidden');
			this.cardsContainer.classList.add('cards-grid');
			if (this.cardsContainer.classList.contains('recommended-projects__empty-container')) {
				this.cardsContainer.classList.remove('recommended-projects__empty-container');
			}
			if (this.projectOverviewButton.classList.contains('btn--secondary')) {
				this.projectOverviewButton.classList.replace('btn--secondary', 'btn--primary');
			}
		}
	},

	filterCards() {
		const params = new URLSearchParams(window.location.search);
		if (this.cardsContainer && this.cardsContainer.children) {
			const cards = Array.from(this.cardsContainer.children);
			this.totalCardsShowing = cards.length;
			if ([...params].length > 0) {
				params.forEach((value, key) => {
					cards.forEach((card) => {
						if (card.dataset) {
							if (card.dataset[key]) {
								const list = card.dataset[key].split(',').map((item) => item.trim());
								const valueArr = value.split(',').map((item) => item.trim());
								if (!list.some((r) => valueArr.includes(r))) {
									Helpers.removeVisibility(card);
									this.totalCardsShowing -= 1;
								} else {
									Helpers.addVisibility(card);
								}
							} else {
								// if the filterkey is not on the card we'll just show the card
								Helpers.addVisibility(card);
							}
						}
					});
				});
				this.renderCardsContainer(this.totalCardsShowing);
			} else {
				// show all
				cards.forEach((card) => {
					Helpers.addVisibility(card);
				});
			}
		}
	},
};

export { OnSelectFilter as default };
